import React, { Component } from 'react';
import { connect } from 'react-redux';
import localforage from 'localforage';
import Cookies from 'universal-cookie';
import Kol_chipinput from '../containers/kol_chipinput';
import Kol_ranking_table from '../components/kol_ranking_table';
import { bindActionCreators } from 'redux';
import { fetch_setQueryInfo } from '../actions/index';
import { fetch_kolranking } from '../actions/fetch_kolranking';
import RaisedButton from 'material-ui/RaisedButton';
import ReactJoyride, { STATUS } from 'react-joyride';
import '../styles/kol.css';
import '../styles/spriteSourceIcon.css';
import $ from 'jquery';
import LoadingBoxes from '../components/loadingBoxes';
import LoadingText from '../components/loadingText';
import { userLogout } from '../utility/logout';
import { introTutorial } from '../utility/introTutorial';

let cookies = new Cookies();

class Kol extends Component {
  constructor(props) {
    super(props)
    this.state = {
      displayNumber: 10,
      totalNumber: 0,
      moreDisable: 'inline-block',
      Pchips: [],
      PcateChips: [],
      Pskills: [],
      Pjobs: [],
      PfansMin: 0.05,
      PfansMax: 3000,
      PdayQuery: 30,
      Pperiod: 1,
      Psex: [0, 1, 2],
      PsourceOption: {
        fbClass: "FB",
        ytClass: "YT",
        igClass: "IG"
      },
      PsourceValue: 'FB,YT,IG',
      Pkol_name: '',
      Pcat_op: 'or',
      run: false,
      steps: introTutorial(),
    }
  }

  loadMoreBtn = () => {
    var newDisplayNumber = this.state.displayNumber + 10;
    if (newDisplayNumber == 100 || this.props.kolranking['leader_value'].length < newDisplayNumber) {
      this.setState({ moreDisable: 'none' });
    }
    this.setState({ displayNumber: newDisplayNumber });
  }

  handleJoyrideCallback = (data) => {
    const { status } = data
    const introTutorialCookie = 365 * 86400

    // jQuery is much easier than checking the state change
    if ($('#react-joyride-portal').length) {
      document.body.classList.add('overflowHidden')
    } else {
      document.body.classList.remove('overflowHidden')
    }

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      cookies.set('introTutorial', 'off', { path: '/', maxAge: introTutorialCookie });
      this.setState({ run: false })
    }

  }

  updateFetchKolranking(tags, cates, fansMin, fansMax, dayQuery, period, sex, sourceOption, sourceValue, kol_name, cat_op, catlistData) {
    let skills = []
    let jobs = []

    if (cates.length) {
      cates.forEach((element, elementIndex) => {
        if (catlistData[element] === '專長') {
          skills.push(element)
        } else {
          jobs.push(element)
        }
      })
    }

    this.setState({ Pchips: tags });
    this.setState({ PcateChips: cates });
    this.setState({ Pskills: skills });
    this.setState({ Pjobs: jobs });
    this.setState({ PfansMin: fansMin });
    this.setState({ PfansMax: fansMax });
    this.setState({ PdayQuery: dayQuery });
    this.setState({ Pperiod: period });
    this.setState({ Psex: sex });
    this.setState({ PsourceOption: sourceOption });
    this.setState({ PsourceValue: sourceValue });
    this.setState({ Pkol_name: kol_name });
    this.setState({ Pcat_op: cat_op });
    this.setState({ displayNumber: 10 });
    this.setState({ moreDisable: 'inline-block' });

    //need to add cate chips in fetch function
    this.props.fetch_setQueryInfo(tags, cates, skills, jobs, fansMin, fansMax, dayQuery, period, sex, sourceOption, sourceValue, kol_name, cat_op)
    this.props.fetch_kolranking(tags, cates, skills, jobs, fansMin, fansMax, dayQuery, sex, sourceValue, kol_name, cat_op, cookies.get('token'))
  }

  componentDidMount() {
    if (!cookies.get('introTutorial')) {
      this.setState({ run: true })
    }

    localforage.getItem('dashQueryValue').then((value) => {
      if (value) {
        this.props.fetch_kolranking(
          value.chipsData,
          value.cateChipsData,
          value.skills,
          value.jobs,
          value.fansMin,
          value.fansMax,
          value.dayQuery,
          value.sex,
          value.sourceValue,
          value.kol_name,
          value.cat_op,
          cookies.get('token')
        )

        this.setState({
          Pchips: value.chipsData,
          PcateChips: value.cateChipsData,
          Pskills: value.skills,
          Pjobs: value.jobs,
          Pperiod: value.period,
          PfansMin: value.fansMin,
          PfansMax: value.fansMax,
          PdayQuery: value.dayQuery,
          Psex: value.sex,
          PsourceOption: value.sourceOption,
          PsourceValue: value.sourceValue,
          Pkol_name: value.kol_name,
          Pcat_op: value.cat_op,
        })
      } else {
        // fetch_kolranking(tagarr,catearr,skillarr,jobarr,fansmin,fansmax,period,sex,source,kol_name,cat_op,token,dispatch)
        this.props.fetch_kolranking([], [], [], [], 0.05, 3000, 30, [0, 1, 2], 'FB,YT,IG', '', 'or', cookies.get('token'))
      }
    }).catch((err) => {
      console.log("err", err);
    })
  }

  componentDidUpdate(prev) {

  }

  resetQueryInfo() {
    this.updateFetchKolranking([], [], 0.05, 3000, 30, 1, [0, 1, 2], { fbClass: "FB", ytClass: "YT", igClass: "IG" }, 'FB,YT,IG', '', 'or', {})
  }

  render() {
    const { run, steps } = this.state;
    const { queryInfo, queryInfo_isloading, kolranking, kolranking_isloading, kolranking_error, login } = this.props;

    if (queryInfo_isloading || kolranking_isloading) {
      return (
        <div>
          <LoadingBoxes />
          <LoadingText />
        </div>
      )
    }

    if (kolranking_error !== false) {
      if (kolranking_error.status === 401) {
        setTimeout(function () { userLogout(); }, 3000);
        return <p className="errormsg">您的登入期間已過期，請重新登入</p>;
      } else {
        return (
          <div className="errormsg">
            <p className="errormsgCenter">資料未完成載入，請稍後再試</p>
            <div className="refreshBtn" onClick={() => this.resetQueryInfo()}>
              <span className="refreshIcon"></span>
              <span className="refreshIconText">重新整理</span>
            </div>
          </div>
        )
      }
    }

    let resultTable = null;
    let moreButton = null;

    if (kolranking !== null && kolranking.hasOwnProperty('leader_value')) {

      resultTable = [<Kol_ranking_table key='leader_value' PqueryInfo={this.state} data={kolranking['leader_value']} allData={kolranking} title="領袖價值" displayNumber={this.state.displayNumber} bgSetting={this.props.bgSetting} />,
      <Kol_ranking_table key='fans_scale' PqueryInfo={this.state} data={kolranking['fans_scale']} allData={kolranking} title="曝光數最多" displayNumber={this.state.displayNumber} bgSetting={this.props.bgSetting} />,
      <Kol_ranking_table key='growth' PqueryInfo={this.state} data={kolranking['growth']} allData={kolranking} title="粉絲成長數" displayNumber={this.state.displayNumber} bgSetting={this.props.bgSetting} />,
      <Kol_ranking_table key='performance' PqueryInfo={this.state} data={kolranking['performance']} allData={kolranking} title="互動最熱絡" displayNumber={this.state.displayNumber} bgSetting={this.props.bgSetting} />,
      <Kol_ranking_table key='relevance' PqueryInfo={this.state} data={kolranking['relevance']} allData={kolranking} title="主題最相關" displayNumber={this.state.displayNumber} bgSetting={this.props.bgSetting} />];
      if (kolranking['leader_value'].length > 10) {
        moreButton = <RaisedButton onClick={this.loadMoreBtn} style={{ display: this.state.moreDisable }}>載入更多…</RaisedButton>;
      }
      else {
        moreButton = <RaisedButton onClick={this.loadMoreBtn} style={{ display: 'none' }}>載入更多…</RaisedButton>;
      }

    }
    else {
      resultTable = <p className="errormsg" style={{ fontSize: '18px', paddingTop: '20px', textAlign: 'center', position: 'relative' }}>查無符合條件的資料，請重新查詢</p>;
      moreButton = <div />;
    }

    return (
      <div className={`kol_options ${this.props.bgSetting}`}>
        <div className="kol_inputWrapper">
          <Kol_chipinput
            PqueryInfo={queryInfo}
            Pchips={this.state.Pchips}
            PcateChips={this.state.PcateChips}
            PfansMin={this.state.PfansMin}
            PfansMax={this.state.PfansMax}
            Pperiod={this.state.Pperiod}
            PdayQuery={this.state.PdayQuery}
            Psex={this.state.Psex}
            PsourceOption={this.state.PsourceOption}
            PsourceValue={this.state.PsourceValue}
            Pkol_name={this.state.Pkol_name}
            Pcat_op={this.state.Pcat_op}
            triggerParentUpdate={this.updateFetchKolranking.bind(this)} />
        </div>
        <div className="kol_ranking">
          {resultTable}
        </div>
        <div className="kol_more">
          {moreButton}
        </div>
        <ReactJoyride
          callback={this.handleJoyrideCallback}
          continuous
          disableOverlayClose
          run={run}
          scrollToFirstStep
          showProgress
          showSkipButton
          steps={steps}
          styles={{
            options: {
              zIndex: 10000,
              primaryColor: '#f48500 ',
            },
            buttonClose: {
              display: 'none',
            }
          }}
          locale={{
            back: '上一步',
            next: '下一步',
            last: '結束',
            skip: <strong aria-label="skip">跳出教學</strong>
          }}
        />
      </div>
    )
  }
}

function mapStateToProps({ queryInfo, queryInfo_isloading, bgSetting, kolranking, kolranking_isloading, kolranking_error, login }) {
  return { queryInfo, queryInfo_isloading, bgSetting, kolranking, kolranking_isloading, kolranking_error, login };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetch_setQueryInfo, fetch_kolranking }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Kol);


// WEBPACK FOOTER //
// ./src/containers/kol.js